import React from 'react';
import DotLoader from 'react-spinners/DotLoader';
import cn from 'classnames';

export const Loading = ({className}: {className?: string}) => {

    return (
        <div className={cn('w-full', className)}>
            <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
                <DotLoader color={'#ED5939'} size="80px" css={'display: block; position: relative;'} />
            </div>
        </div>
    )

}